import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Wallet, ChevronRight } from "lucide-react";
import { Button, Card, CardContent } from "@tabipla/ui";

interface SettlementBannerProps {
  groupId: string;
}

export function SettlementBanner({ groupId }: SettlementBannerProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card className="border-orange-200 bg-orange-50 dark:border-orange-800 dark:bg-orange-950">
      <CardContent className="p-4">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-orange-500 text-white">
            <Wallet className="h-6 w-6" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="font-bold text-orange-900 dark:text-orange-100">
              {t("trips.settlementBanner.title")}
            </h3>
            <p className="text-sm text-orange-600 dark:text-orange-400">
              {t("trips.settlementBanner.description")}
            </p>
          </div>
          <Button
            size="sm"
            className="shrink-0 bg-orange-600 hover:bg-orange-700"
            onClick={() => navigate(`/groups/${groupId}`)}
          >
            <ChevronRight className="mr-1 h-4 w-4" />
            {t("trips.settlementBanner.action")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
